import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import SettingPrompt from "../../../../components/SettingPrompt";
import {
  Box,
  Layout,
  Page,
  PageActions,
  Toast,
  Text,
  BlockStack,
  InlineStack,
  Button,
  Card,
  Badge,
  SkeletonBodyText,
  Banner,
} from "@shopify/polaris";
import intl from "../../../../i18n/intl";
import "./index.css";
import NavTabs from "../components/NavTabs";
import BasicPriceBox from "./components/BasicPriceBox";
import AdvancedPriceBox from "./components/AdvancedPriceBox";
import { store } from "../../../../store";
import { changeBannerData } from "../../../../slice";
import ApplyRules from "./components/ApplyRules";
import _ from "lodash";
import { reqGetInfoSetting, reqGetNewSubscribeList, reqPostNewSubscribeChange, reqPutSettingPricing } from "../../../../api";
import EnoughQuotaModal from "../../ProductSelection/SourcingRequest/component/EnoughQuotaModal";
import PersonalAgentModal from "../../SubscriptionPaid/components/PersonalAgentModal";
import defalutData from "../../SubscriptionPaid/components/subData";
import { useSelector } from "react-redux";
const Index = ({changeSettingBtnState,changeCancelSettingBtnState}) => {
  const shopify = window.shopify;
  // 配置保存按钮
  const [btnSaveState, setBtnSaveState] = useState({
    saveDataLoading: false,
    disabledSaveData: true,
  });
  const [ApplyRulesModal,setApplyRulesModal] = useState('');
  const [applyRulesData,setApplyRulesData] = useState(
    {
      showApplyRulesCountBanner: false,
      disableApplyRules: false,
      applyRulesCount: 0
    }
  );
  const plan_level = useSelector(
    (state) => state.languageReducer.subScriptData
  );
  // 次数不足
  const [sourcingLimitModal,setSourcingLimitModal] = useState(false)
  const [initPage,setInitPage] = useState(true);
    
    // 数据内容
    const [pageData, setPageData] = useState({});
    // 使用 useRef 保存初始数据和初始化状态
    const initialPageData = useRef(null);
    const isInitialized = useRef(false);
   // 使用 ref 保存函数引用（避免重复绑定到 window）
    const saveDataRef = useRef();
    const cancelDataRef = useRef();
 
  useEffect(() => {
    let isOp = false;
    if (!isOp) {
      getSubscribeList()
    }
    return () => {
      isOp = true;
    };
   // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
    //  获取数据
    const getPageData = async () => {
      try {
        let res = await reqGetInfoSetting({type:'price'});
        if (res.code === '200') {
          setPageData(res.data);
          setApplyRulesData((prev)=>({
            ...prev,
            showApplyRulesCountBanner: res.data.applyRulesCount !== 0 ? true : false,
            applyRulesCount: res.data.applyRulesCount,
          }))
          initialPageData.current = _.cloneDeep(res.data);
        }else {}
        setInitPage(false)
      } catch (error) {
      }
    };
    useEffect(() => {
          window.saveSettings = {saveData:saveData};
          window.cancelSetting = {cancelData:cancelData}
           // eslint-disable-next-line
        }, []);
      const cancelData = () => {
        setPageData((prev)=>({
          ...prev,
          ...initialPageData.current,
        }))
        changeSettingBtnState(false)
        setBtnSaveState(prev => ({
          ...prev,
          disabledSaveData: true
        }));
      }
    // 保存数据
    const saveData = async () => {
      if (Number(pageData?.advanced_price_rule_on) === 1) {
        if (Number(pageData?.level) === 0 || Number(pageData?.level) === 4) {
          setSourcingLimitModal(true)
          return
        }
      }
        try {
          setBtnSaveState(prev => ({
            ...prev,
            saveDataLoading: true
          }));
        
        let params = {
          general_rule:pageData.general_rule,
          advanced_price_rule_on:pageData.advanced_price_rule_on,
          advanced_rule:pageData.advanced_rule
        }
        if (pageData.level === 0 || pageData.level === 4){
          params.advanced_rule = initialPageData?.current?.advanced_rule
        }
        const res = await reqPutSettingPricing(params)
        if (res.code === '200') {
          // success
          setBtnSaveState(prev => ({
            ...prev,
            disabledSaveData: true,
            saveDataLoading: false
          }));
          initialPageData.current = _.cloneDeep(pageData);
          setTimeout(() => {
            changeSettingBtnState(false)
          }, 1000);
          toastFun('Saved successfully')
        }else{
          changeSettingBtnState(false)
          store.dispatch(changeBannerData({bannerData:{
            show:true,
            desc:res.msg
          }}));
        }
        } catch (error) {
        }
    }
     // 更新 ref 的当前值（每次函数更新时同步）
      useEffect(() => {
        saveDataRef.current = saveData;
        cancelDataRef.current = cancelData;
      });
      useEffect(() => {
        if (!isInitialized.current) {
          // 组件首次加载时，记录初始数据并标记初始化完成
          getPageData();
          
          isInitialized.current = true;
        } else {
          // 后续数据变动时，比较当前数据与初始数据
          const isDataChanged = !_.isEqual(pageData, initialPageData.current);
          setBtnSaveState(prev => ({
            ...prev,
            disabledSaveData: !isDataChanged
          }));
          if (isDataChanged) {
            window.saveSettings = { saveData: saveDataRef.current };
            window.cancelSetting = { cancelData: cancelDataRef.current };
          }
        }
         // eslint-disable-next-line
      }, [pageData]); // 监听 pageData 的变化
       useEffect(() => { 
          changeSettingBtnState(!btnSaveState.disabledSaveData)
        }, [btnSaveState,changeSettingBtnState]);
      // 组件卸载时清理
      useEffect(() => {
        return () => {
          window.saveSettings = null;
          window.cancelSetting = null;
        };
      }, []);
      // 价格规则应用到产品数据中
 const handleApplyRules = () => {
    let content = <ApplyRules show={true} callBackFun={handleCallbackApplyRule} />
    setApplyRulesModal(content)
  }

  // 价格规则应用确认回调（显示需要更新记录数）
 const handleCallbackApplyRule = (data) => {
    if (data !== '') {
      setApplyRulesData((prev)=>({
        ...prev,
        showApplyRulesCountBanner: true,
        disableApplyRules: true,
        applyRulesCount: data.count || 0
      }))
      
    }
  }


    const [planShow, setPlanShow] = useState(true);
    const [subList, setSubList] = useState(defalutData.subList); // 套餐列表
    // 积分剩余
    const [userPoints,setUserPoints] = useState({
      userPointsData:{
        available_points:0,
        total_points:0
      },
      userPointsRedeem:{
        open:false,
        id:0,
        isDetail:false,
        is_new:0,
        isPoints:false
      },
    })
    // 高级套餐
    const [premiumData, setPremiumData] = useState({
      open: false,
      agent_list: [],
    });
    const handlePremiumOff = () => {
      setPremiumData((prevValue) => ({
        ...prevValue,
        open: false,
      }));
    };
     const enhancePackageList = (
       list,
       currentPlanId,
       pricingData,
       trialDays,
       agentList,
       firstPurchase,
       isZt,
       glassesLevel
     ) => list.map(item => {
       const priceInfo = pricingData.find(p => p.key === item.id) || {};
       const isCurrentPlan = item.id === currentPlanId;
       const isAnnualPlan = priceInfo?.is_yearly === 1;
       let button = "";
       let disabled = false;
       if (glassesLevel === 1) {// 当前为年套餐页
         if (isAnnualPlan) {
           if (isCurrentPlan) {// 当前为年套餐页、未购买年套餐的
             if (currentPlanId === 0) {
               // 未付费用户
               button = "Current Plan";
               disabled = true;
             } else if (item.id === 0) {
               button = "Downgrade";
             } else {
               button = "Current Plan";
               disabled = true;
             }
           } else if (
             (item.id === 0 && item.id !== currentPlanId) ||
             (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
           ) {
             button = "Downgrade";
           } else if (currentPlanId !== 4 && item.id < currentPlanId) {
             button = "Downgrade";
           } else if (trialDays !== 0 && item.id !== 4) {
             button =  `Start ${trialDays}-day free trial`;
           } else {
             button = "Select Plan";
           }
         } else {
           if (isCurrentPlan) {
             if (currentPlanId === 0) {
               // 未付费用户
               button = "Current Plan";
               disabled = true;
             }else if (item.id === 4 && currentPlanId === 0) {
               button = "Select Plan";
             } else {
               button = "Downgrade";
             }
           } else if (
             (item.id === 0 && item.id !== currentPlanId) ||
             (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
           ) {
             if (item.id === 4 && currentPlanId === 0) {
               button = "Select Plan";
             }else {
               button = "Downgrade";
             }
           } else if (currentPlanId !== 4 && item.id < currentPlanId) {
             button = "Downgrade";
           } else if (trialDays !== 0 && item.id !== 4) {
             button = `Start ${trialDays}-day free trial`;
           } else {
             if (item.id === 4 && currentPlanId === 0) {
               button = "Select Plan";
             }else {
               button = "Downgrade";
             }
           }
           
         }
       }else {
         if (isAnnualPlan) {
           if (isCurrentPlan) {// 当前为年套餐页、未购买年套餐的
             if (currentPlanId === 0) {
               // 未付费用户
               button = "Current Plan";
               disabled = true;
             } else if (item.id === 0) {
               button = "Downgrade";
             }else if (trialDays !== 0  && item.id !== 4) {
               button =  `Start ${trialDays}-day free trial`;
             } else {
               button = "Select Plan";
             }
           } else if (
             (item.id === 0 && item.id !== currentPlanId)
           ) {
             button = "Downgrade";
           } else if (trialDays !== 0 && item.id !== 4) {
             button =  `Start ${trialDays}-day free trial`;
           } else {
             button = "Select Plan";
           }
         } else {
           if (isCurrentPlan) {
             if (currentPlanId === 0) {
               // 未付费用户
               button = "Current Plan";
               disabled = true;
             } else if (item.id === 0) {
               button = "Downgrade";
             } else {
               button = "Current Plan";
               disabled = true;
             }
           } else if (
             (item.id === 0 && item.id !== currentPlanId) ||
             (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
           ) {
             button = "Downgrade";
           } else if (currentPlanId !== 4 && item.id < currentPlanId) {
             button = "Downgrade";
           } else if (trialDays !== 0  && item.id !== 4) {
             button = `Start ${trialDays}-day free trial`;
           } else {
             button = "Select Plan";
           }
           
         }
         
       }
     
       return {
         ...item,
         ...priceInfo,
         first_purchase: firstPurchase,
         is_zt: isZt,
         bill_level: currentPlanId,
         agent: item.id === 5 ? agentList : [],
         button,
         disabled,
         loading:false
       };
     });
   // 获取套餐数据
     const getSubscribeList = async () => {
       try {
         let res = await reqGetNewSubscribeList();
         if (res.code === "200") {
           const {
            level,
             trial_days,
             agent_list,
             first_purchase,
             is_zt,
             glasses_level,
           } = res.data;
           setPremiumData((prevValue) => ({
             ...prevValue,
             agent_list: res.data.agent_list,
           }));
           setPlanShow((glasses_level === 1 ) ? false : true)
           // 处理月套餐
           const enhancedMonth = enhancePackageList(
             subList.month,
             level,
             res.data.package.month,
             trial_days,
             agent_list,
             first_purchase,
             is_zt,
             glasses_level
           );
           // 处理年套餐
           const enhancedYear = enhancePackageList(
             subList.year,
             level,
             res.data.package.year,
             trial_days,
             agent_list,
             first_purchase,
             is_zt,
             glasses_level
           );
   
           setSubList((prev) => ({
             ...prev,
             month: enhancedMonth,
             year: enhancedYear,
           }));
         }
       } catch (error) {}
     };
     // 升降级
     const handleMageUpgrade = async ( 
       id,
       val = '',
       email = "",
       social = "",
       am_id = "",
     )=>{
       try {
         let param = {
           package_id: id,
           email: email,
           social: social,
           am_id: am_id,
           is_yearly:!planShow ? 1 : 0,
         };
         if (val && val !== "") {
           param.remark = val;
         }
       
       let res = await reqPostNewSubscribeChange(param);
       if (res.code === "200") {
        if (res?.data?.id !== "") {
          if (id !== 0) {
            window.top.location.href = res.data.url;
            toastFun(res.msg);
          }
        }
      } else {
        toastFun(intl.get("Something wrong"));
      }
     } catch (error) {
         
     }
     }
     
    const handleSubmit = (val) => {
      if (val) {
          if (val === 5) {
              setPremiumData((prevValue) => ({
                  ...prevValue,
                  open: true,
                }));
              setSourcingLimitModal(false)
          }
          if (val === 6) {
            setUserPoints((prevValue)=>({
              ...prevValue,
              userPointsRedeem:{
                ...prevValue.userPointsRedeem,
                isPoints:true
              }
            }))
            setSourcingLimitModal(false)
            
          }
          if (val <5) {
            handleMageUpgrade(val)
          }
      }
    };
    const handleTogglePriceBox = (val)=>{
      setPageData(prev=>({
        ...prev,
        advanced_price_rule_on:Number(val)
      }))
    }

  // 判断等级是否是pro plus
  const isProPlus = useMemo(() => {
    let flag = false;
      if (plan_level.bill_level ===0 || plan_level.level === 4) {
        flag = true;
      }
    return flag;
  }, [plan_level]);

  const [toast, setToast] = useState(false); // 提示
  const [toastError, setToastError] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  
  const toggleToast = useCallback(() => setToast((toast) => !toast), []);

  const toastMarkup = toast ? (
    <Toast content={toastMsg} onDismiss={toggleToast} error={toastError} />
  ) : null;

  const toastFun = (msg, error) => {
    setToastError(error);
    setToastMsg(msg);
    setToast(false);
    toggleToast();
  };
  const applyRulesCountBanner = applyRulesData.showApplyRulesCountBanner && <div style={{ marginBottom: '20px' }}>
  <Banner tone='warning'>
  Price update in progress. Products remaining: {' ' + applyRulesData.applyRulesCount}
  </Banner>
</div>
  const pageContent = (
    <Box className='price_page'>
      <BlockStack gap={400}>
        {applyRulesCountBanner}
        <Box className='h1_m'>
        <InlineStack gap={200} align="space-between">
          <Text variant="headingLg" as="h5">
            Smart price setting
          </Text>
          {<Button variant="plain" disabled={applyRulesData.showApplyRulesCountBanner} onClick={()=>{handleApplyRules()}}>{'Apply rules to existing products'}</Button>}
        </InlineStack>
        </Box>
        <Card roundedAbove="xs">
          <BlockStack gap={500}>
            <Box>
              <Text variant="headingSm" as="h6">
                Please select your pricing strategy template
              </Text>
              <Text as="p" tone="subdued">
              Products imported into the Product Center will be auto-priced based on your pricing rule
              </Text>
            </Box>
            <Box>
              <InlineStack gap={300}>
                <Box className={`samrt_toggle_price_item ${pageData?.advanced_price_rule_on === 0 ? 'samrt_toggle_price_item_active':''}`} onClick={()=>handleTogglePriceBox(0)}>
                  <BlockStack gap={200}>
                  <Box className='samrt_toggle_price_child_active'>
                    <Card padding={0} roundedAbove="xs">
                      <Box style={{ background: "rgba(247, 247, 247, 1)",height:"80px",padding:'8px 12px' }}>
                        <InlineStack align="space-between">
                          <Box style={{fontSize:'14px',fontWeight:650}}></Box>
                          <Box>
                            <Badge tone="success"><span className='color1_price'>FREE</span></Badge>
                          </Box>
                        </InlineStack>
                        <Box style={{fontSize:'14px',fontWeight:650,textAlign:'center'}}>Basic Rules</Box>
                      </Box>
                    </Card>
                  </Box>
                  <Box>
                    <Text as="p" tone="subdued" variant="bodySm">
                    The simplest pricing strategy is to apply a fixed markup multiplier.
                    </Text>
                  </Box>
                </BlockStack></Box>
                <Box className={`samrt_toggle_price_item ${pageData?.advanced_price_rule_on === 1 ? 'samrt_toggle_price_item_active':''}`} style={{opacity:isProPlus ? 0.7 : 1}} onClick={()=>{
                  if (isProPlus) return;
                  handleTogglePriceBox(1)
                }}> 
                  <BlockStack gap={200}>
                  <Box className='samrt_toggle_price_child_active'>
                    <Card padding={0} roundedAbove="xs">
                      <Box style={{ background: "rgba(247, 247, 247, 1)",height:"80px",padding:'8px 12px' }}>
                        <InlineStack align="space-between">
                        <Box style={{fontSize:'14px',fontWeight:650}}></Box>
                          <Box>
                            <Badge tone="success"><span className='color1_price'>PRO and above</span></Badge>
                          </Box>
                        </InlineStack>
                        <Box style={{fontSize:'14px',fontWeight:650,textAlign:'center'}}>Advanced Rules</Box>
                      </Box>
                    </Card>
                  </Box>
                  <Box>
                    <Text as="p" tone="subdued" variant="bodySm">
                    Flexible strategies including tiered pricing, custom markup rules, and psychological pricing.
                    </Text>
                  </Box>
                </BlockStack></Box>
                
               
              </InlineStack>
            </Box>
            {pageData?.advanced_price_rule_on === 0 ? <BasicPriceBox pageData={pageData} setPageData={setPageData}/> :
            <AdvancedPriceBox pageData={pageData} setPageData={setPageData} toastFun={toastFun}/>}
          </BlockStack>
        </Card>
      </BlockStack>
    </Box>
  );
  const initSkeletonPage = (
     <Box className="skeleton_page">
        <Box className="skeleton_page_children">
          <Card>
          <BlockStack gap={400}>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          </BlockStack>
          </Card>
          </Box>
          </Box>
      )
  return (
    <div className={shopify ? "setting_page_shopify" : "setting_page"}>
      {!shopify && (
        <SettingPrompt
          disabledSaveData={btnSaveState.disabledSaveData}
          url="/admin/settings/price"
          saveData={saveData}
        />
      )}
      <Page title={shopify ? "" : intl.get("Settings")} separator>
        <Layout>
          <Layout.Section variant="oneThird">
            <NavTabs
              selected="Smart price setting"
              saveData={saveData}
              loading={btnSaveState.saveDataLoading}
              disabled={btnSaveState.disabledSaveData}
            />
          </Layout.Section>
          <Layout.Section> 
            {initPage && initSkeletonPage }
            <Box style={{opacity: initPage ? 0 : 1}}>
            {pageContent}
            </Box>
          </Layout.Section>
        </Layout>
        {toastMarkup}
        {sourcingLimitModal && <EnoughQuotaModal 
        type={'price_setting'} 
        handleSubmit={handleSubmit} 
        planShow={planShow}  
        sourcingLimitModal={sourcingLimitModal} 
        userPoints={userPoints} 
        subList={subList} 
        changeCancelSettingBtnState={changeCancelSettingBtnState}
        setSourcingLimitModal={setSourcingLimitModal}/>}
        {/* agent选择 */}
        {premiumData.open && <PersonalAgentModal
          premiumData={premiumData}
          handlePremiumOff={handlePremiumOff}
          handleMageUpgrade={handleMageUpgrade}
        />}
          <PageActions
            primaryAction={{
              content: intl.get("Save"),
              onAction: saveData,
              loading: btnSaveState.saveDataLoading,
              disabled: btnSaveState.disabledSaveData,
            }}
          ></PageActions>
        {ApplyRulesModal}
      </Page>
    </div>
  );
};

export default Index;
